import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { BaseResponse } from "../../typings/interfaces";
import { ISpecialChargeConfig } from "../../typings/interfaces/responses/special-charge-response";
import { SPECIAL_CHARGE_CONFIG } from "../../configs/apiConfig";

// The BE reports failures as HTTP 200 + status FAILED
const bodyOrReject = (data: BaseResponse<ISpecialChargeConfig>, rejectWithValue: (v: string) => any) =>
    data.status === "SUCCESS" ? data : rejectWithValue(data.message || "Special charges could not be loaded");

export const getSpecialChargesAction = createAsyncThunk(
    "special-charges/get",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get<BaseResponse<ISpecialChargeConfig>>(SPECIAL_CHARGE_CONFIG);
            return bodyOrReject(response.data, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);

export const saveSpecialChargesAction = createAsyncThunk(
    "special-charges/save",
    async (configs: ISpecialChargeConfig[], { rejectWithValue }) => {
        try {
            const response = await axios.put<BaseResponse<ISpecialChargeConfig>>(SPECIAL_CHARGE_CONFIG, configs);
            return bodyOrReject(response.data, rejectWithValue);
        } catch (err: any) {
            return rejectWithValue(err.response?.data?.message || err.message);
        }
    }
);
